export enum PdpLocations {
	Main = 'main',
	Sticky = 'sticky',
	CrossSellingSimilars = 'pdp-cross-selling:similars',
	CrossSellingTotalLook = 'pdp-cross-selling:total-look',
	CrossSellingPersonalization = 'pdp-cross-selling:recommended',
	CrossSellingLastViewed = 'pdp-cross-selling:last-viewed',
}
